import { Grid } from '@mui/material';
import Panel from '../../../../components/UI/Panel';
import CheckboxInput from '../UI/CheckboxInput';

export default function DepartmentServePreferencesCaseInfo({
  form,
}: {
  form: any;
}) {
  return (
    <Panel headerText="Case">
      <Grid container>
        <Grid item xs={6}>
          <CheckboxInput
            label="Required Date Of Loss"
            checked={
              form?.values?.custodianDetails?.servePreferences
                ?.isRequiredDateOfLoss
            }
            keyName={`${form}.values.custodianDetails.servePreferences.isRequiredDateOfLoss`}
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isRequiredDateOfLoss`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isRequiredDateOfLoss`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6} pl={3}>
          <CheckboxInput
            label="Claim number"
            checked={
              form?.values?.custodianDetails?.servePreferences?.isClaimNumber
            }
            keyName={`${form}.values.custodianDetails.servePreferences.isClaimNumber`}
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isClaimNumber`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isClaimNumber`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <CheckboxInput
            label="Requires Specific Dates of Service"
            checked={
              form?.values?.custodianDetails?.servePreferences
                ?.isRequiresSpecificDatesOfService
            }
            keyName={`${form}.values.custodianDetails.servePreferences.isRequiresSpecificDatesOfService`}
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isRequiresSpecificDatesOfService`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isRequiresSpecificDatesOfService`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6} pl={3}>
          <CheckboxInput
            label="Requires DOB"
            checked={
              form?.values?.custodianDetails?.servePreferences?.isRequiresDOB
            }
            keyName={`${form}.values.custodianDetails.servePreferences.isRequiresDOB`}
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isRequiresDOB`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isRequiresDOB`,
                true,
              );
            }}
          />
        </Grid>
      </Grid>
    </Panel>
  );
}
